import { useTranslation } from "react-i18next";
import { toAbsoluteUrl } from "../../../_metronic/helpers";

type Props = {
	isVisible: boolean;
	onConfirm(): void;
	title:string;
	titleMessage:string;
}

const IdleTimeoutModal = ({ isVisible, onConfirm,titleMessage, title }: Props) => {
	const { t } = useTranslation();
	const styles = isVisible ? { display: 'block' } : { display: 'none' };

	return (
		<div
			className={`modal animate__animated animate__fadeIn ${isVisible ? 'show four' : ''}`}
			tabIndex={-1}
			id="idle-timeout-modal"
			style={styles}
			data-bs-backdrop="static"
			data-bs-keyboard="false"
		>
			<div className="modal-dialog modal-dialog-centered animate__animated animate__faster animate__zoomIn">
				<div className="modal-content bg-light-danger radius-12px">
					<div className="modal-body mx-auto" style={{ padding: "30px 60px 25px" }}>
						<img alt='Logo' src={toAbsoluteUrl('/media/logos/session.png')} className='h-80px' />
						<h5 className="fw-bolder text-center fs-1 mb-5">{t(title)}</h5>
						<h5
							className="modal-title text-center text-gray-900 mb-5"
							style={{
								fontSize: "14px",
								fontWeight: 400,
								fontStyle: "normal",
							}}
						>
							{t(titleMessage)}
						</h5>
						<div className="d-flex flex-center flex-wrap">
							<button
								type="button"
								className="btn btn-danger w-125px rounded-pill"
								style={{ margin: "0px", fontSize: "13.5px" }}
								data-bs-dismiss="modal"
								onClick={onConfirm}
							>
								{t('okay')}
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export { IdleTimeoutModal };
